//export const API_BASE_URL = "https://matriculas.cervantes.edu.ec/api";
export const API_BASE_URL = "https://www.matriculas.liceocampoverde.edu.ec/api";
//export const API_BASE_URL = "http://localhost:3846/api";